// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Utils
import { getElementId } from '../../../../../../common/elements/utils/elementPropertyUtils';
import { getEventSelectionMode } from '../../../../../element/selection/selectionUtils';
import { isLine } from '../../../../../../common/elements/utils/elementTypeUtils';
import { getObserverRootOptions } from '../../../../../element/elementVisibility/elementContentVisibleObserverUtils';

// Singletons
import currentlyVisibleElementsSingleton from '../../../../../element/elementVisibility/currentlyVisibleElementsSingleton';

// Decorators
import renderElementPlaceholderDecorator from '../../../../../element/elementPlaceholder/renderElementPlaceholderDecorator';
import measureElementDecorator from '../../../../../components/measurementsStore/elementMeasurements/measureElementDecorator';

// Selectors
import makeElementSelector, { getElement } from '../../../../../element/selectors/elementSelector';

// Actions
import { handleSelectionModeSelectElement } from '../../../../../element/actions/elementSelectionActions';

// Components
import DraggableElement from '../../../../../element/dnd/DraggableElement';
import Element from '../../../../../element/Element';
import { zoomStateContextConsumer } from '../../../../../canvas/zoom/ZoomStateContext';
import ElementContentVisibleObserver from '../../../../../element/elementVisibility/ElementContentVisibleObserver';

// Styles
import './TrashElement.scss';

const mapStateToProps = () =>
    createStructuredSelector({
        element: getElement,
    });

const mapDispatchToProps = (dispatch) => ({
    dispatchHandleSelectionModeSelectElement: (id, selectionMode, transactionId) =>
        dispatch(handleSelectionModeSelectElement(id, selectionMode, transactionId)),
});

@connect(mapStateToProps, mapDispatchToProps)
@connect(makeElementSelector)
@zoomStateContextConsumer
@DraggableElement
@measureElementDecorator
@renderElementPlaceholderDecorator
class TrashElement extends React.Component {
    componentWillMount() {
        const { connectDragPreview } = this.props;
        if (connectDragPreview) {
            connectDragPreview(getEmptyImage());
        }
    }

    componentWillUnmount() {
        currentlyVisibleElementsSingleton.remove(this.props.elementId);
    }

    onPointerDown = (event) => {
        event.stopPropagation();
    };

    onClick = (event) => {
        event && event.stopPropagation();

        const { element, dispatchHandleSelectionModeSelectElement } = this.props;

        const selectionMode = getEventSelectionMode(event);

        return dispatchHandleSelectionModeSelectElement(getElementId(element), selectionMode);
    };

    elementEvents = {
        onPointerDown: this.onPointerDown,
        onClick: this.onClick,
    };

    render() {
        const {
            connectDragSource,
            element,
            elementId,
            measureElementRef,
            onVisibilityChange,
            shouldRenderPlaceholder,
            placeholderElement,
            allowElementPlaceholder,
            inTrash,
            boardSection,
        } = this.props;

        const observerRootOptions = getObserverRootOptions(boardSection, inTrash);

        return connectDragSource(
            <div className="TrashElement" ref={measureElementRef}>
                <ElementContentVisibleObserver
                    domRef={measureElementRef}
                    onVisibilityChange={onVisibilityChange}
                    enable={!isLine(element)}
                    observerRootOptions={observerRootOptions}
                    setContentVisibility={!allowElementPlaceholder}
                    elementId={elementId}
                />
                {shouldRenderPlaceholder ? (
                    placeholderElement
                ) : (
                    <Element {...this.props} elementEvents={this.elementEvents} onClick={this.onClick} />
                )}
            </div>,
        );
    }
}

TrashElement.propTypes = {
    element: PropTypes.object,
    connectDragSource: PropTypes.func,
    connectDragPreview: PropTypes.func,
    dispatchHandleSelectionModeSelectElement: PropTypes.func,
    measureElementRef: PropTypes.object,
    onVisibilityChange: PropTypes.func,
    shouldRenderPlaceholder: PropTypes.bool,
    placeholderContainerStyle: PropTypes.object,
    placeholderClasses: PropTypes.string,
    placeholderElement: PropTypes.node,
    allowElementPlaceholder: PropTypes.bool,
    elementId: PropTypes.string,
    inTrash: PropTypes.bool,
    boardSection: PropTypes.string,
};

const TrashElementWrapper = (props) => {
    // ListElement class must be outside TrashElement so that it's not included in the measurements
    return (
        <div className="ListElement">
            <TrashElement {...props} />
        </div>
    );
};

export default TrashElementWrapper;
